<div class="lds-ring" [style.width.px]="diameter || null" [style.height.px]="diameter || null">
  <div [style.border-width.px]="strokeWidth"></div>
  <div [style.border-width.px]="strokeWidth"></div>
  <div [style.border-width.px]="strokeWidth"></div>
  <div [style.border-width.px]="strokeWidth"></div>
</div>
